import { fromPromise } from "rxjs/internal-compatibility";
import { GtCaptchaApi } from "./GtCaptchaApi";
export function requestGtCaptcha(params) {
  return fromPromise(GtCaptchaApi.shared.requestGtCaptcha(params));
}